import { CloudOff, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Logo } from "@/components/Logo";
import heroGradient from "@/assets/hero-gradient.jpg";
import northLogoWhite from "@/assets/north-logo-white.png";

export function ServiceUnavailable() {
  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Hero Gradient Background */}
      <div
        className="absolute inset-0 -z-10 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroGradient})` }}
      >
        <div className="absolute inset-0 bg-background/40 backdrop-blur-sm" />
      </div>

      {/* Main Content */}
      <div className="flex min-h-screen flex-col items-center justify-center px-4 py-16">
        <div className="w-full max-w-2xl">
          {/* Logo */}
          <div className="mb-8 flex justify-center">
            <Logo customLogoUrl={northLogoWhite} size="lg" />
          </div>

          {/* Main Card */}
          <Card className="relative overflow-hidden border-2 p-8 text-center shadow-lg md:p-12">
            {/* Decorative gradient overlay */}
            <div
              className="absolute right-0 top-0 h-32 w-32 opacity-10 blur-2xl"
              style={{
                background: 'linear-gradient(135deg, hsl(190 95% 55%), hsl(270 85% 65%))',
              }}
            />

            <div className="relative z-10">
              {/* Icon */}
              <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-[hsl(190_95%_55%)] via-[hsl(220_90%_60%)] to-[hsl(270_85%_65%)] opacity-90">
                <CloudOff className="h-10 w-10 text-white" strokeWidth={2} />
              </div>

              {/* Message */}
              <h2 className="mb-3 text-2xl font-semibold tracking-tight md:text-3xl">
                We'll be right back
              </h2>
              <p className="mb-8 text-lg text-muted-foreground">
                Our database provider is currently experiencing issues. This is outside of our
                control, but we're monitoring the situation and everything should be back to normal
                shortly.
              </p>

              {/* Reconnecting indicator */}
              <div className="mb-8 flex items-center justify-center gap-2 text-sm text-muted-foreground">
                <span className="relative flex h-2.5 w-2.5">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary/60" />
                  <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-primary" />
                </span>
                Automatically reconnecting...
              </div>

              {/* Actions */}
              <div className="flex flex-col gap-3 sm:flex-row sm:justify-center">
                <Button
                  size="lg"
                  className="gap-2"
                  onClick={() => window.location.reload()}
                >
                  <RefreshCw className="h-5 w-5" />
                  Try Again
                </Button>
                <Button
                  asChild
                  variant="outline"
                  size="lg"
                >
                  <a href="/">Go to Homepage</a>
                </Button>
              </div>
            </div>
          </Card>

          {/* Support link */}
          <div className="mt-6 text-center">
            <p className="text-sm text-white">
              If this persists, please{" "}
              <a
                href="mailto:support@northreports.com"
                className="text-white hover:underline"
              >
                contact support
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
